import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  getClientsDetails,
  getProductsResume,
} from '../../services/ProductService/getProducts'

export const useProductsDetails = () => {
  const { id } = useParams()
  const [productResume, setProductResume] = useState<GetProductResumeType>()
  const [clientsDetails, setClientsDetails] = useState<GetDetailsType[]>([])
  const [clientsLow, setClientsLow] = useState<GetDetailsType[]>([])
  const [isLoading, setIsloading] = useState(true)

  const handleProductsResume = async () => {
    setIsloading(true)
    const result = await getProductsResume(id!)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setProductResume(result)
    }
  }

  const handleClientsDetails = async (
    status: Classification,
    callback: (result: GetDetailsType[]) => void
  ) => {
    setIsloading(true)
    const result = await getClientsDetails(id!, status)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      callback(result)
    }
  }

  const handleClientsInHigh = (result: GetDetailsType[]) => {
    const resultMapped = result.map(product => ({
      ...product,
      percentual: String(product.percentual).replace('.', ','),
    }))
    setClientsDetails(resultMapped)
  }

  const handleClientsLow = (result: GetDetailsType[]) => {
    const resultMapped = result.map(product => ({
      ...product,
      percentual: String(product.percentual).replace('.', ','),
    }))
    setClientsLow(resultMapped)
  }

  useEffect(() => {
    handleProductsResume()
  }, [])

  useEffect(() => {
    handleClientsDetails('EM_ALTA', handleClientsInHigh)
    handleClientsDetails('EM_BAIXA', handleClientsLow)
  }, [])

  return {
    productResume,
    clientsDetails,
    clientsLow,
    isLoading,
  }
}
